module.exports = __webpack_public_path__ + "static/media/Bed.5817a97d.png";